export enum QuickActionsEnum {
	WatchButton = 'WATCH',
}
